import { db_loading_type } from "../interfaces";

declare const db_loading: db_loading_type;
declare const self: { db_version: { [key: string]: number } };
declare const set_db: (db_name: string, list: { url: string; kind?: string }[] | undefined, value: any) => Promise<void>;

// 開啟 indexedDB
export default function open_db(db_name: string, list: { url: string; kind?: string }[] | undefined, is_second?: boolean): Promise<IDBDatabase | void> {
  return (
    new Promise((resolve: (value?: unknown) => void, reject: (reason?: any) => void): IDBDatabase | void => {
      let db: IDBDatabase;
      const DBRequest: IDBOpenDBRequest = indexedDB.open(db_name, self.db_version[db_name]);

      // 當 indexedDB 需要升級時
      DBRequest.onupgradeneeded = function (event: any): void {
        db = event.target.result;
        list?.forEach((item) => {
          try {
            db.createObjectStore(item.url);
          } catch (err) {
            console.error(err);
          }
        });

        // 資料庫升級成功
        DBRequest.onsuccess = (event: any): void => {
          if (event && event.target) db = event.target.result;
          !db_name.includes("version") && set_db(`${db_name}_version`, [{ url: "version" }], self.db_version[db_name]);
          db_loading[db_name] = db;
          (self as any).db_is_open = true;
          resolve(db);
        };
        // 資料庫升級失敗
        DBRequest.onerror = (): void => {
          console.error("Error upgrading database.");
          reject();
        };
      };
      // 資料庫開啟成功
      DBRequest.onsuccess = (event: any): void => {
        db = event.target.result;
        db_loading[db_name] = db;
        resolve(db);
      };
      // 資料庫開啟失敗
      DBRequest.onerror = (err: any): void => {
        console.error("Error opening database.", err);
        if (!is_second) {
          self.db_version[db_name] += 1;
          // db.close();
          resolve(open_db(db_name, list, true));
        } else reject();
      };
    })
      // 將開啟後的資料庫回傳
      .then((db: unknown): IDBDatabase => db as IDBDatabase)
  );
}
